import Toast, { PluginOptions } from "vue-toastification";

import "vue-toastification/dist/index.css";

const toast = Toast

export { toast }